import React, { Component, Fragment } from 'react';
import { ButtonTheme } from '@philips-internal/oswald-ui-constants';
import { classNames, isEnumValid, trigger } from '@philips-internal/oswald-ui-utils';
import './swipe.css';
function getCursorXPosition(event) {
    if ('touches' in event) {
        return event.touches[0].clientX;
    }
    return event.clientX;
}
class Swipe extends Component {
    constructor() {
        super(...arguments);
        this.containerWidth = 0;
        this.initialTranslate = 0;
        this.startPosition = 0;
        this.state = {
            touching: false,
            translate: 0,
        };
        this.onMouseDown = (event) => {
            const { enabled } = this.props;
            const { touching, translate } = this.state;
            if (!enabled || touching) {
                return;
            }
            this.initialTranslate = translate;
            this.startPosition = getCursorXPosition(event);
            this.setState({ touching: true }, () => this.bindEvents());
        };
        this.onMouseMove = (event) => {
            const { touching } = this.state;
            if (!touching) {
                return;
            }
            const xPosition = getCursorXPosition(event);
            if (xPosition > this.startPosition - this.initialTranslate) {
                return this.setState({ translate: 0 });
            }
            const translate = xPosition - this.startPosition + this.initialTranslate;
            this.setState({ translate });
        };
        this.onMouseUp = () => {
            const { actions, actionWidth = Swipe.defaultProps.actionWidth } = this.props;
            const { translate } = this.state;
            const width = actionWidth * actions.length;
            const acceptableMove = (actionWidth * -1) * .7;
            const showActions = translate < acceptableMove;
            this.startPosition = -1;
            this.setState(() => {
                const value = showActions ? (width * -1) : 0;
                return {
                    touching: false,
                    translate: value,
                };
            }, () => this.unbindEvents());
        };
        this.swipeRef = (element) => {
            if (element) {
                this.containerWidth = element.getBoundingClientRect().width;
            }
        };
    }
    componentDidMount() {
        const { actions } = this.props;
        if (actions.length > 3) {
            throw new Error('[Swipe]: It\'s only possible to use three actions with the Swipe component.');
        }
        // We have to do a `forceUpdate` here to get the `swipeRef` call, to populate
        // the `containerWidth` value.
        this.forceUpdate();
    }
    componentWillUnmount() {
        this.unbindEvents();
    }
    bindEvents() {
        window.addEventListener('mousemove', this.onMouseMove);
        window.addEventListener('mouseup', this.onMouseUp);
        window.addEventListener('touchend', this.onMouseUp);
        window.addEventListener('touchmove', this.onMouseMove);
    }
    unbindEvents() {
        window.removeEventListener('mousemove', this.onMouseMove);
        window.removeEventListener('mouseup', this.onMouseUp);
        window.removeEventListener('touchend', this.onMouseUp);
        window.removeEventListener('touchmove', this.onMouseMove);
    }
    renderActions() {
        const { actions, actionWidth } = this.props;
        const actionsStyle = {
            marginLeft: `${this.containerWidth - actionWidth}px`,
        };
        return (React.createElement(Fragment, null,
            React.createElement("div", { className: "c-swipe__background", style: actionsStyle }),
            React.createElement("div", { className: "c-swipe__actions", style: actionsStyle }, actions.map((action) => {
                const { icon, key, onClick, theme = Swipe.defaultProps.theme } = action;
                const actionStyle = {
                    width: `${actionWidth}px`,
                };
                const className = classNames({
                    'c-swipe__action': true,
                    [`c-swipe__action--${theme}`]: isEnumValid(ButtonTheme, theme),
                });
                return (React.createElement("div", { className: className, key: key, onClick: trigger(onClick), style: actionStyle }, icon));
            }))));
    }
    renderContent() {
        const { children } = this.props;
        const { translate } = this.state;
        const contentStyle = {
            transform: `translateX(${translate}px)`,
        };
        return (React.createElement("div", { className: "c-swipe__content", onMouseDown: this.onMouseDown, onTouchStart: this.onMouseDown, style: contentStyle }, children));
    }
    render() {
        const { className: customClassName } = this.props;
        const { touching } = this.state;
        const className = classNames({
            'c-swipe': true,
            'c-swipe--touching': touching,
            [`${customClassName}`]: Boolean(customClassName),
        });
        return (React.createElement("div", { className: className, ref: this.swipeRef },
            this.renderActions(),
            this.renderContent()));
    }
}
Swipe.defaultProps = {
    actions: [],
    actionWidth: 78,
    enabled: true,
    theme: ButtonTheme.PRIMARY,
};
export { Swipe, };
export default Swipe;
//# sourceMappingURL=swipe.js.map